module.exports = __webpack_public_path__ + "ico-growth.png?7de43040d7f92a22edceb8d92ea985ac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/ico-growth.png
// module id = 943
// module chunks = 0